import React from 'react';
import type { OffhoursProxyResponse } from '../../api/offhoursMarketProxyApi';

function n(value: unknown): number | null {
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

function pct(value: unknown): string {
  const parsed = n(value);
  if (parsed == null) return '—';
  return `${parsed > 0 ? '+' : ''}${parsed.toFixed(2)}%`;
}

function price(value: unknown): string {
  const parsed = n(value);
  if (parsed == null) return '—';
  return new Intl.NumberFormat('ko-KR', { maximumFractionDigits: 4 }).format(parsed);
}

function tone(value: unknown): string {
  const parsed = n(value);
  if (parsed == null) return 'is-neutral';
  if (parsed > 0.05) return 'is-up';
  if (parsed < -0.05) return 'is-down';
  return 'is-neutral';
}

export default function OffhoursMarketProxyCard({ data }: { data: OffhoursProxyResponse | null }) {
  if (!data?.displayEligible || data.mode !== 'ACTIVE' || !Array.isArray(data.items) || data.items.length === 0) {
    return null;
  }

  return (
    <section className="live-summary-offhours-proxy" aria-label="24H 해외 파생 프록시">
      <header className="live-summary-offhours-proxy__head">
        <div>
          <small>OFFICIAL MARKET GAP</small>
          <b>{data.label || '24H 해외 파생 프록시'}</b>
        </div>
        <span>공식시장 공백 보조</span>
      </header>

      <div className="live-summary-offhours-proxy__grid">
        {data.items.map((item) => {
          const change = item.windowAnchorChangePct ?? item.providerPrevChangePct;
          return (
            <article key={`${item.provider || 'proxy'}:${item.providerSymbol || item.underlyingCode || item.displayName}`}>
              <small>{item.displayName || item.providerSymbol || item.underlyingCode}</small>
              <strong>{price(item.markPx ?? item.midPx)}</strong>
              <em className={tone(change)}>{pct(change)}</em>
              <span>{item.windowAnchorChangePct != null ? '' : 'provider 기준 대비'}</span>
            </article>
          );
        })}
      </div>

      <p>{data.disclaimer || 'KRX/NXT/미국 현물의 현재가가 아닌 해외 파생 proxy입니다.'}</p>
    </section>
  );
}
